const AVATAR_COLORS = [
  '#007C68', '#0E7490', '#7C3AED', '#DB2777',
  '#EA580C', '#CA8A04', '#16A34A', '#2563EB',
  '#9333EA', '#DC2626', '#0891B2', '#65A30D',
];

export function getInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

export function getAvatarColor(name: string): string {
  let hash = 0;
  for (const char of name) {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]!;
}
